import { FC, useState } from "react";
import { Campaign } from "@vviinn/user-managment-client-ts";

import { NamedRow } from "../../../../../components/GeneralUI/NamedRow/NamedRow";
import { CampaignTileFooter } from "../../../../components/CampaignTileFooter";

import {
  assignedCategoriesPredicate,
  calculateAssignedCategories,
} from "../../../helpers";
import { useAppSelector } from "../../../../../store";
import { SlideOverCampaignCategories } from "./SlideOverCampaignCategories";
import { Fields } from "../../../../../ui/layout/detailedPages/Fields";
import {
  GROUP_STYLES,
  SUB_HEADER_STYLES,
} from "../../../../../ui/layout/detailedPages/styles";
import { Restricted } from "../../../../../components/Restricted";

const getCategoriesTextContent = (amount: number) =>
  amount === 0 ? "All products" : amount;
const getCategoriesRowContent = (
  sourceCategoriesAmount: number,
  targetCategoriesAmount: number,
  isVpcCampaign: boolean,
) => {
  if (isVpcCampaign) {
    return sourceCategoriesAmount === 0 && targetCategoriesAmount === 0
      ? "All products"
      : `${getCategoriesTextContent(
          sourceCategoriesAmount,
        )} -> ${getCategoriesTextContent(targetCategoriesAmount)}`;
  }

  return getCategoriesTextContent(targetCategoriesAmount);
};

export const AssignedProducts: FC<{ campaign: Campaign }> = ({ campaign }) => {
  const [assignedCategoriesModal, setAssignedCategoriesModal] = useState(false);
  const categoryTree = useAppSelector((state) => state.categories.categories);

  const { sourceCategoriesAmount, targetCategoriesAmount, categoriesAmount } =
    calculateAssignedCategories(campaign);
  const isVpcCampaign = campaign?.type === "VPC";

  return (
    <Restricted permissions="campaign:linked_categories:view">
      <div className="w-full overflow-hidden">
        {assignedCategoriesPredicate(campaign) ? (
          <Fields title="Products">
            <NamedRow
              title="Assigned Products"
              editPermissions="campaign:advanced_config:update"
              content={getCategoriesRowContent(
                sourceCategoriesAmount,
                targetCategoriesAmount,
                isVpcCampaign,
              )}
              fixedHeight={true}
              onClick={() => setAssignedCategoriesModal(true)}
            />

            <div className="px-4 pb-4">
              <CampaignTileFooter
                campaign={campaign}
                categories={categoryTree}
              />
            </div>
          </Fields>
        ) : (
          <>
            <h6 className={`pt-8 ${SUB_HEADER_STYLES}`}>Products</h6>
            <div className={`mt-4 ${GROUP_STYLES}`}>
              <div className="py-4 text-center text-sm text-stone-700 dark:text-stone-300">
                No linked categories.
              </div>
            </div>
          </>
        )}
        <SlideOverCampaignCategories
          assignedCategories={
            campaign?.linkedCategories ?? {
              target: { googleFeedCategories: [] },
            }
          }
          tree={categoryTree}
          slideOpen={assignedCategoriesModal}
          onSlideClose={() => setAssignedCategoriesModal(false)}
          isVpcCampaign={isVpcCampaign}
          categoriesAmount={categoriesAmount}
        />
      </div>
    </Restricted>
  );
};
